import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import { Button, Form, FormGroup, Input, Label, Table, Modal, ModalHeader, ModalBody, ModalFooter, Badge,Alert } from 'reactstrap';
import moment from 'moment';
import LoadingSpin from "react-loading-spin";
import { connect } from 'react-redux';

class DormAssign extends Component {
    static displayName = DormAssign.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            permissionFlag: true,
            loadingFlag: true,
            closedFlag: "",
            dormAssignData: [],
            fullDormAssign: [],
            dormOverviewData: [],
            buildVal: "DEFAULT",
            buildName: "",
            buildList: [],
            roomVal: "DEFAULT",
            roomNumber: "",
            stuA: "",
            stuB: "",
            stuC: "",
            stuD: "",
            roomList: [],
            requestModal: false,
            requestMessage: "",
            resLifeViewRoom: "DEFAULT",
            allStu: [],
            //viewType: this.props.reduxData.userInfo.level.dept.substring(0, 8) != "STUDENTS" && this.props.reduxData.userInfo.level.dept.substring(0, this.props.reduxData.userInfo.level.dept.indexOf("-") - 1) != "INFO TECHNOLOGY" ? true : false //true for employee, false for student
            viewType: false,
            group: [],
            groupStudentsList: [],
            groupStudentsSelected: []
        }
        //this.testPermission();
        this.apiFetch("ValidDepartments", { pagepk: "1042" }, "permissionFlag")
    }

    async apiFetch(url, body, stateItem) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            ...body
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.props.reduxData.apiKey },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        if (stateItem != "" && stateItem != null) {
            this.setState({
                [stateItem]: data
            })
            if (url == "ValidDepartments") {
                //this.getOverviewData();
                this.apiFetch("GetDormOverviewData", {},"dormOverviewData")
                //this.getTableData();
                
                //this.apiFetch("SelfAssignGetUserGroup", {}, "group")
            }
            if (url == "GetDormAssignData") {
                this.apiFetch("SelfAssignGetUserGroup", {}, "group")
                this.apiFetch("SelfAssignGroupStudentOptions", {}, "groupStudentsList")
                
            }
            if (url == "SelfAssignGetUserGroup") {
                if (data.pk != null) {
                    this.setState({
                        loadingFlag: false,
                        stuA: data.group1.pcid,
                        stuB: data.group2.pcid,
                        stuC: data.group3.pcid,
                        stuD: data.group4.pcid != null ? data.group4.pcid : ""
                    })
                }
                else {
                    this.setState({
                        loadingFlag: false
                    })
                }
            }
            if (url == "GetDormOverviewData") {
                this.apiFetch("GetDormAssignData", {}, "dormAssignData")
                this.apiFetch("SelfAssignAllStu", {}, "allStu")
                var buildVAR = [];
                data.map((item) => {
                    var findItem = buildVAR.find((x) => x.buildCode === item.buildCode);
                    if (!findItem) buildVAR.push(item);
                })
                var closedBOOL = "closed";
                if (data.length >= 2) closedBOOL = "open";
                else if (data.length == 1) closedBOOL = "group";
                this.setState({
                    buildList: buildVAR,
                    closedFlag: closedBOOL
                })
            }
        }
        if (stateItem == "") {
            return data
        }
        if (stateItem == null) {
            if (url == "DormSelfAssignConfirmReq") {
                if (data.success == 0) {
                    this.setState({
                        requestModal: true,
                        requestMessage: data.returnMessage
                    })

                }
                this.apiFetch("GetDormOverviewData", {}, "dormOverviewData")
                this.apiFetch("GetDormAssignData", {}, "dormAssignData")
            }
            if (url == "DormAssignAddGroup" || url == "SelfAssignLeaveGroup") {
                this.apiFetch("GetDormOverviewData", {}, "dormOverviewData")
            }
        }
    }

    componentDidMount() {
    }

    async submitButton(e) {
        e.preventDefault();
        let errorCount = 0;
        var internalRoomSize = this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize;
        var roomID = this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomID;
        if (errorCount === 0) {
            let toSend = {
                stuA: this.state.stuA,
                stuB: this.state.stuB,
                stuC: this.state.stuC,
                stuD: this.state.stuD
            }
            const data = await this.apiFetch("CheckSelfAssignReq", toSend, "")
            var filteredStu = data.filter(x => x.pcid != this.props.reduxData.userInfo.pcid)
            let confirmMessage = "You are about to request " + this.state.buildName + " room " + roomID;
            switch (internalRoomSize) {
                case "2":
                    confirmMessage = confirmMessage + " with " + filteredStu[0].stuName + " as a roommate."
                    break;
                case "1":
                    confirmMessage = confirmMessage + "."
                    break;
                case "3":
                    confirmMessage = confirmMessage + " with " + filteredStu[0].stuName + " and " + filteredStu[1].stuName + " as roommates."
                    break;
                case "4":
                    confirmMessage = confirmMessage + " with " + filteredStu[0].stuName + ", " + filteredStu[1].stuName + ", and " + filteredStu[2].stuName + " as roommates."
                    break;
                default:
                    confirmMessage = confirmMessage + ""
                    break;
            }
            confirmMessage = confirmMessage + " Are you sure?";
            if (filteredStu[0].email == "ERROR") {
                let errorMessage = "There was a problem with your submission. Please confirm that you are making this request at the proper time for your class, that all of your requested roommates are current students, and that none of your requested roommates are already requested in a different room."
                this.setState({
                    requestModal: true,
                    requestMessage: errorMessage
                })
            }
            else {
                this.setState({
                    requestModal: true,
                    requestMessage: confirmMessage
                })
            }
        }
        else {
            let errorMessage = "There was a problem with your submission. Please confirm that you have entered your requested roommates' full Hood email address, not their names or their usernames or their ID numbers."
            this.setState({
                requestModal: true,
                requestMessage: errorMessage
            })
        }
    }

    async confirmSubmit() {
        let toSend = {
            stuA: this.state.stuA,
            stuB: this.state.stuB,
            stuC: this.state.stuC,
            stuD: this.state.stuD,
            build: this.state.buildVal,
            room: this.state.roomNumber
        }
        this.apiFetch("DormSelfAssignConfirmReq", toSend, null)
    }

    async approveRequest() {
        let toSend = {
            pk: this.state.dormAssignData[0].pk,
            command: "A"
        }
        this.apiFetch("DormRequestStuAction",toSend, "dormAssignData")
    }

    async denyRequest() {
        let toSend = {
            pk: this.state.dormAssignData[0].pk,
            command: "D"
        }
        this.apiFetch("DormRequestStuAction", toSend, null)
        this.setState({
            dormAssignData: []
        })
        this.apiFetch("GetDormOverviewData", {}, "dormOverviewData")
    }

    groupShopping(pcid) {
        //console.log("check default: ", pcid)
        if (pcid != "DEFAULT") {
            //console.log("group shopping start")
            let entry = {
                pcid: pcid.slice(0,pcid.indexOf("|")),
                name: pcid.slice(pcid.indexOf("|")+1)
            }
            //console.log("group shopping entry: ", entry)
            if (!this.state.groupStudentsSelected.some(i => i.pcid == entry.pcid) && this.state.groupStudentsSelected.length < 3) {
                //add
                this.setState({
                    groupStudentsSelected: [...this.state.groupStudentsSelected, entry]
                })
            }
            else {
                //remove
                this.setState({
                    groupStudentsSelected: this.state.groupStudentsSelected.filter((i) => i.pcid != entry.pcid)
                })
            }
        }
    }

    async createGroup() {
        let toSend = {
            one: this.state.groupStudentsSelected[0].pcid,
            two: this.state.groupStudentsSelected[1].pcid,
            three: this.state.groupStudentsSelected.length == 3 ? this.state.groupStudentsSelected[2].pcid : ""
        }
        this.setState({
            loadingFlag: true,
            groupStudentsSelected: []
        })
        this.apiFetch("DormAssignAddGroup", toSend, null)
    }

    overviewTable() {
        return (<div>
            <Table>
                <thead>
                    <tr>
                        <th>Room number</th>
                        <th>Room size</th>
                        <th>Room Attributes</th>
                        <th>Availability</th>
                        {<th></th>}
                        {/*<th>Occupancy List</th>*/}
                    </tr>
                </thead>
                <tbody>
                    {this.state.dormOverviewData.filter((build) => build.buildCode == this.state.buildVal).map(item => (
                        <tr>
                            <td>{item.roomID}</td>
                            <td>{item.roomSize}</td>
                            <td>{item.roomAttr}</td>
                            <td style={{ color: (item.roomStatus.includes('Available') ? 'green' : 'red') }}>{item.roomStatus}</td>
                            {!item.roomStatus.includes('Available') ? <td><Button outline onClick={() => { this.setState({ resLifeViewRoom: item.roomID }); this.props.updateFetchTime(); }}>View</Button></td> : this.state.viewType && <td></td>}
                            {/*<td>{JSON.stringify(item.claimantList)}</td>*/}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>)
    }

    buildSelect() {
        return (
            <div className="quarterOfParent">
            <Form>
                    <Input type="select" name="building_select" id="building_select" value={this.state.buildVal} onChange={(e) => {
                        this.setState({
                            buildVal: e.target.value,
                            roomVal: "DEFAULT",
                            buildName: e.target.options[e.target.selectedIndex].text,
                            stuA:  this.state.group.pk != null ? this.state.group.group1.pcid : "" ,
                            stuB: this.state.group.pk != null ? this.state.group.group2.pcid : "",
                            stuC: this.state.group.pk != null ? this.state.group.group3.pcid : "",
                            stuD: this.state.group.pk != null ? this.state.group.group4.pcid : "" 
                        }); this.props.updateFetchTime();
                    
                }}>
                <option value="DEFAULT" disabled>Select Building</option>
                        {this.state.buildList.map(item => (
                            <option key={ item.clientPK} value={item.buildCode}>{item.buildName}</option>
                ))}
                    </Input>
                </Form>
            </div>
        )
    }

    

    studentView() {
        if (!this.state.loadingFlag) {
            if (this.state.dormAssignData.length > 0) {
                return (<div>
                    {this.state.dormAssignData[0].isFinal == "N"
                        ? < h3 > You have been requested to be a roommate with the following students in {this.state.dormAssignData[0].room.slice(0, -1)}</h3>
                        : < h3 > You have been officially registered in our student information system to be a roommate with the following students in {this.state.dormAssignData[0].room.slice(0, -1)}</h3>}<p />
                    <Table>
                        <thead>
                            <tr>
                                <th>Room</th>
                                <th>Student</th>
                                <th>Availability Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.dormAssignData.map(item => (
                                <tr>
                                    <td>{item.room}</td>
                                    <td>{item.pcid == this.props.reduxData.userInfo.pcid ? "You!" : item.stuName}</td>
                                    <td>{item.stuStatus == "Awaiting Response..." && item.pcid == this.props.reduxData.userInfo.pcid && item.isFinal == "N"
                                        ? <div>{item.approveMarker == 'Y' && <Button outline onClick={() => this.approveRequest()}>Approve</Button>}<Button outline onClick={() => this.denyRequest()}>Deny</Button>
                                            &ensp;&ensp;&ensp;{this.state.group.pk != null && <span>This will remove the entire group from this room. If you wish to only remove yourself, contact Res Life.</span>}</div>
                                        : item.stuStatus}</td>
                                    <td>{item.pcid == this.props.reduxData.userInfo.pcid && item.stuStatus == "Approved" && item.isFinal == "N" ? <Button outline color="danger" onClick={() => { this.denyRequest(); this.props.updateFetchTime(); } } >Remove Me</Button> :<div></div> }</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>)
            }
            else {
                return (
                    <div>
                        <Modal isOpen={this.state.requestModal} toggle={this.requestModalFlip.bind(this)}>
                            <ModalHeader toggle={this.requestModalFlip.bind(this)}></ModalHeader>
                            <ModalBody>
                                {this.state.requestMessage}
                            </ModalBody>
                            <ModalFooter>
                                {!this.state.requestMessage.includes("Your request") && <Button color="success" onClick={() => { this.confirmSubmit(); this.props.updateFetchTime(); }}>Confirm</Button>}
                            </ModalFooter>
                        </Modal>
                        <span>I am requesting:</span><p />
                        <Form>
                            <FormGroup>
                                <Label>Building: </Label>
                                {this.buildSelect()}
                            </FormGroup>
                            {this.state.buildVal != "DEFAULT" &&
                                <FormGroup>
                                    <Label>Room: </Label>
                                    <div className="quarterOfParent">
                                        <Input type="select" name="room_input" id="room_input" value={this.state.roomVal} onChange={(e) => {
                                            this.setState({
                                                roomVal: e.target.value,
                                                roomNumber: e.target.options[e.target.selectedIndex].text,
                                                stuA: this.state.group.pk > 0 ? this.state.group.group1.pcid : "",
                                                stuB: this.state.group.pk > 0 ? this.state.group.group2.pcid : "",
                                                stuC: this.state.group.pk > 0 ? this.state.group.group3.pcid : "",
                                                stuD: this.state.group.pk > 0 ? this.state.group.group4.pcid : "" 
                                            }); this.props.updateFetchTime();
                                        }
}>
                                            <option value="DEFAULT" disabled>Select... </option>
                                            {this.state.dormOverviewData.filter((build) => build.buildCode == this.state.buildVal && build.roomStatus != "Confirmed" && build.isFinalized == "N" &&
                                                (!build.roomStatus.includes("1/1") && !build.roomStatus.includes("2/2") && !build.roomStatus.includes("3/3") && !build.roomStatus.includes("4/4"))).map(item => (
                                                <option key={item.clientPK} value={item.clientPK}>{item.roomID}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </FormGroup>
                            }
                            {this.state.roomVal != "DEFAULT" && this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize > 0 &&
                                <div>
                                    < FormGroup >
                                        <Label>Roommate A</Label>
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "A")).length == 0 &&                                        
                                            <div className="quarterOfParent">
                                                <Input type="select" name="studentA" id="studentA" value={this.state.stuA} onChange={(e) => { if (this.state.group.pk == null) { this.setState({ stuA: e.target.value }); this.props.updateFetchTime(); } }}>
                                                    <option value="" disabled={this.state.group.pk > 0 ? true : false}>No Preference</option>
                                                    {this.state.allStu.filter((stu) => stu.pcid != this.state.stuB && stu.pcid != this.state.stuC && stu.pcid != this.state.stuD).map(item => (
                                                        <option value={item.pcid} disabled={this.state.group.pk > 0 ? true : false}>{item.name} ({item.email})</option>
                                                    ))}
                                                </Input>
                                            </div>
                                        }
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "A")) != 0 &&
                                        <div>
                                                <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "A").stu}</strong><br />
                                                <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "A").email}</strong>
                                            </div>}
                                    </FormGroup>
                                </div>
                            }
                            {this.state.roomVal != "DEFAULT" && this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize > 1 &&
                                <FormGroup>
                                    <Label>Roommate B</Label>
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "B")).length == 0 &&
                                        <div className="quarterOfParent">
                                            <Input type="select" name="studentB" id="studentB" value={this.state.stuB} onChange={(e) => { if (this.state.group.pk == null) { this.setState({ stuB: e.target.value }); this.props.updateFetchTime(); } }}>
                                                <option value="" disabled={this.state.group.length > 0 ? true : false}>No Preference</option>
                                                {this.state.allStu.filter((stu) => stu.pcid != this.state.stuA && stu.pcid != this.state.stuC && stu.pcid != this.state.stuD).map(item => (
                                                    <option value={item.pcid} disabled={this.state.group.pk > 0 ? true : false}>{item.name} ({item.email})</option>
                                                ))}
                                            </Input>
                                        </div>}
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "B")) != 0 &&
                                        <div>
                                            <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "B").stu}</strong><br />
                                            <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "B").email}</strong>
                                        </div>}
                                </FormGroup>
                            }
                            {this.state.roomVal != "DEFAULT" && this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize > 2 &&
                                <FormGroup>
                                    <Label>Roommate C</Label>
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "C")).length == 0 &&
                                        <div className="quarterOfParent">
                                            <Input type="select" name="studentC" id="studentC" value={this.state.stuC} onChange={(e) => { if (this.state.group.pk == null) { this.setState({ stuC: e.target.value }); this.props.updateFetchTime(); } } }>
                                                <option value="" disabled={this.state.group.length > 0 ? true : false}>No Preference</option>
                                                {this.state.allStu.filter((stu) => stu.pcid != this.state.stuA && stu.pcid != this.state.stuB && stu.pcid != this.state.stuD).map(item => (
                                                    <option value={item.pcid} disabled={this.state.group.pk > 0 ? true : false}>{item.name} ({item.email})</option>
                                                ))}
                                            </Input>
                                        </div>}
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "C")) != 0 &&
                                        <div>
                                            <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "C").stu}</strong><br />
                                            <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "C").email}</strong>
                                        </div>}
                                </FormGroup>
                            }
                            {this.state.roomVal != "DEFAULT" && this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).roomSize > 3 &&
                                <FormGroup>
                                    <Label>Roommate D</Label>
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "D")).length == 0 &&
                                        <div className="quarterOfParent">
                                            <Input type="select" name="studentD" id="studentD" value={this.state.stuD} onChange={(e) => { if (this.state.group.pk == null) { this.setState({ stuD: e.target.value }); this.props.updateFetchTime(); } } }>
                                                <option value="" disabled={this.state.group.length > 0 ? true : false}>No Preference</option>
                                                {this.state.allStu.filter((stu) => stu.pcid != this.state.stuA && stu.pcid != this.state.stuC && stu.pcid != this.state.stuB).map(item => (
                                                    <option value={item.pcid} disabled={this.state.group.pk > 0 ? true : false}>{item.name} ({item.email})</option>
                                                ))}
                                            </Input>
                                        </div>}
                                    {this.state.dormOverviewData.filter((room) =>
                                        room.clientPK == this.state.roomVal &&
                                        room.claimantList.some(e => e.seat == "D")) != 0 &&
                                        <div>
                                            <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "D").stu}</strong><br />
                                            <strong>{this.state.dormOverviewData.find((x) => x.clientPK === this.state.roomVal).claimantList.find((y) => y.seat == "D").email}</strong>
                                        </div>}
                                </FormGroup>
                            }
                            {this.state.roomVal != "DEFAULT" && <Button color="success" onClick={(e) => { this.confirmSubmit(e); this.props.updateFetchTime(); } }>Submit</Button>}
                        </Form>
                        {this.state.buildVal != "DEFAULT" && this.overviewTable()}
                    </div>
                )
            }
        }
    }

    requestModalFlip() {
        this.setState({
            requestModal: !this.state.requestModal
        })
    }

    groupView() {
        let displayThis = <div></div>
        if (this.state.group.leader != null) {
            displayThis = this.groupTable()
        }
        else {displayThis = this.groupAdd()}
        return (<div>
            <Alert color="danger">Warning: All members of a group <b>must</b> confirm their membership as soon as possible. Groups will be locked the day before the dorm claiming period begins, and <b>all groups without everyone's approval will be disbanded automatically.</b><br />
                At that point, any changes to group membership must be done by contacting Residence Life.
            </Alert>
            <br />
            {displayThis}</div>)
    }

    groupTable() {
        let hasConfirmed = true
        if (//todo: find an easier way to do this
            (this.props.reduxData.userInfo.pcid == this.state.group.group1.pcid && this.state.group.group1.deleted == "True")
            || (this.props.reduxData.userInfo.pcid == this.state.group.group2.pcid && this.state.group.group2.deleted == "True")
            || (this.props.reduxData.userInfo.pcid == this.state.group.group3.pcid && this.state.group.group3.deleted == "True")
            || (this.props.reduxData.userInfo.pcid == this.state.group.group4.pcid && this.state.group.group4.deleted == "True")
        ) {
            hasConfirmed = false
        }
        return(<div>
                <h2>Group Management</h2><br />
                <Table>
                    <thead>
                        <tr>
                            <th>Member 1</th>
                            <th>Member 2</th>
                            <th>Member 3</th>
                            <th>Member 4</th>
                            <th>Leader</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ color: this.state.group.group1.deleted == "True" ? "black" : "red"  } }>{this.state.group.group1.name}</td>
                            <td style={{ color: this.state.group.group2.deleted == "True" ? "black" : "red"  } }>{this.state.group.group2.name}</td>
                            <td style={{ color: this.state.group.group3.deleted == "True" ? "black" : "red" }}>{this.state.group.group3.name}</td>
                            <td style={{ color: this.state.group.group4.deleted == "True" ? "black" : "red" }}>{this.state.group.group4.name}</td>
                            <td>{this.state.group.leadername}</td>
                        </tr>
                    </tbody>
                </Table>
                <br />
                <Button color={hasConfirmed ? "success" : "danger"} 
                        onClick={() => this.apiFetch("SelfAssignGroupConfirmFlip", {}, "group")}
                 >{hasConfirmed ? "Confirm" : "Remove confirmation"}</Button>
            {hasConfirmed && <Button onClick={() => { this.setState({ loadingFlag: true }); this.apiFetch("SelfAssignLeaveGroup", {}, null) }}>Leave group</Button>}
            </div>)
    }

    groupAdd() {
        return (<div>
            
            <h3>I would like to have in my group...</h3><br />
            <Form className="d-flex fortyPercent">
                <Input type="select" name="studentPick" id="studentPick" value="DEFAULT" onChange={(e) => this.groupShopping(e.target.value)}>
                    <option value="DEFAULT" disabled>Select...</option>
                    {this.state.groupStudentsList.filter((student) => 
                         !this.state.groupStudentsSelected.some(item => item.pcid == student.pcid)
                    ).map(item => (
                        <option value={item.pcid + "|" + item.name}>{item.name} ({item.email})</option>
                    ))}
                </Input>
            </Form>
            <br />
            {this.state.groupStudentsSelected.map(item => (
                <Badge>{item.name} <Button close onClick={(e) => this.groupShopping(item.pcid + "|" + item.name)}/></Badge>
            ))}
            <br /><br />
            {this.state.groupStudentsSelected.length >= 2 && this.state.groupStudentsSelected.length <= 3 &&
                <Button onClick={() => this.createGroup() }>...and me</Button>}
        </div>)
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        let displaySwitch = <div><LoadingSpin size="30px" primaryColor="#132E53" /></div>
        if (this.state.loadingFlag) { //This is for when someone presses the group button, it needs to go back to loading while it processes
            displaySwitch = <div><LoadingSpin size="30px" primaryColor="#132E53" /></div>
        }
        if (!this.state.loadingFlag) {
            if (this.state.closedFlag == "group") { displaySwitch = this.groupView() }
            else { displaySwitch = this.studentView() }
        }
        //This is pretty scary, but if I just have the substring if statement at top level, the page crashes because it tries to evaluate the if statement before the user fetch can set its state
        return (<div>
            <Modal isOpen={this.state.requestModal} toggle={this.requestModalFlip.bind(this)}>
                <ModalHeader toggle={this.requestModalFlip.bind(this)}></ModalHeader>
                <ModalBody>
                    {this.state.requestMessage}
                </ModalBody>
                <ModalFooter>
                    {!this.state.requestMessage.includes("Your request") && <Button color="success" onClick={() => { this.confirmSubmit() }}>Confirm</Button>}
                </ModalFooter>
            </Modal>
            {this.state.closedFlag == "closed" && <div>
                <h2>Our apologies, but self-assigning dorms has closed for the year.</h2><p />
                <h3>If you have any questions, please contact Residence Life.</h3>
            </div>}
            {displaySwitch}
        </div>);
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(DormAssign);